import { Fragment } from "react"
import { Outlet } from "react-router-dom"

const ExpenseWrapper = () => {

    return (
        <Fragment>
           <Outlet/>
        </Fragment>
    )
}

export default ExpenseWrapper